import { Component, inject, input, OnInit } from '@angular/core';
import { MenuItem } from 'src/app/models/menu-item';
import { SessionService } from 'src/app/services/session.service';
import { PopoverButton, PopoverButtonsComponent } from '../popover-buttons/popover-buttons.component';
import { RouterModule } from '@angular/router';
import { LogoComponent } from '../logo/logo.component';
import { ButtonComponent } from '../form/button/button.component';
import { TextButtonComponent } from '../form/text-button/text-button.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [PopoverButtonsComponent, RouterModule, LogoComponent, ButtonComponent, TextButtonComponent]
})
export class NavbarComponent {

  sessionService = inject(SessionService);

  menuItems = input.required<MenuItem[]>();
  popoverButtons = input<PopoverButton[]>([]);
  hideLogo = input<boolean>(false);
}
